(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  class ReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rq-reviews__track');
      this.prev = this.querySelector('.rq-reviews__nav--prev');
      this.next = this.querySelector('.rq-reviews__nav--next');
      this.dotsBox = this.querySelector('.rq-reviews__dots');
      this.cards = Array.from(this.querySelectorAll('.rq-reviews__card'));

      if (!this.track || !this.cards.length) return;

      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.buildDots();

      this.prev?.addEventListener('click', () => this.scrollToCard(this.activeIndex() - 1));
      this.next?.addEventListener('click', () => this.scrollToCard(this.activeIndex() + 1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);

      this.update();
      this.setupAutoplay();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.pause();
      if (this.visibilityHandler) {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
    }

    setupAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (this.cards.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const seconds = parseFloat(this.dataset.interval) || 5;
      this.autoplayDelay = Math.max(2000, seconds * 1000);

      this.play = this.play.bind(this);
      this.pause = this.pause.bind(this);

      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.play);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.play);

      this.visibilityHandler = () => (document.hidden ? this.pause() : this.play());
      document.addEventListener('visibilitychange', this.visibilityHandler);

      this.play();
    }

    play() {
      if (!this.autoplayDelay || this.timer || document.hidden) return;
      this.timer = setInterval(() => {
        const next = this.activeIndex() + 1;
        this.scrollToCard(next >= this.cards.length ? 0 : next);
      }, this.autoplayDelay);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    buildDots() {
      this.dotsBox.replaceChildren();
      this.dots = this.cards.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `الرأي ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToCard(i));
        this.dotsBox.appendChild(dot);
        return dot;
      });
    }

    scrollToCard(index) {
      const clamped = Math.max(0, Math.min(this.cards.length - 1, index));
      const card = this.cards[clamped];
      /* Scroll ONLY the track — scrollIntoView would also scroll the page vertically. */
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const delta = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
      this.track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    activeIndex() {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const edgeName = rtl ? 'right' : 'left';
      const edge = this.track.getBoundingClientRect()[edgeName];

      let best = 0;
      let min = Infinity;

      this.cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect()[edgeName] - edge);
        if (distance < min) {
          min = distance;
          best = i;
        }
      });

      return best;
    }

    onScroll() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.update);
    }

    update() {
      const index = this.activeIndex();
      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = Math.abs(this.track.scrollLeft) < 4;
      const atEnd = Math.abs(Math.abs(this.track.scrollLeft) - maxScroll) < 4;

      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }
  }

  if (!customElements.get('reviews-slider')) {
    customElements.define('reviews-slider', ReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-slider"] && !Shopify.designMode) return;
  try {
    
  class TrustSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rq-trust__track');
      this.prev = this.querySelector('.rq-trust__nav--prev');
      this.next = this.querySelector('.rq-trust__nav--next');
      this.dotsBox = this.querySelector('.rq-trust__dots');
      this.cards = Array.from(this.querySelectorAll('.rq-trust__card'));

      if (!this.track || !this.cards.length) return;

      this.update = this.update.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.buildDots();

      this.prev?.addEventListener('click', () => this.scrollToCard(this.activeIndex() - 1));
      this.next?.addEventListener('click', () => this.scrollToCard(this.activeIndex() + 1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);

      this.update();
      this.setupAutoplay();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.pause();
      if (this.visibilityHandler) {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
    }

    setupAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (this.cards.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const seconds = parseFloat(this.dataset.interval) || 4;
      this.autoplayDelay = Math.max(2000, seconds * 1000);

      this.play = this.play.bind(this);
      this.pause = this.pause.bind(this);

      /* Pause while the visitor is interacting; resume when they leave. */
      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.play);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.play);

      this.visibilityHandler = () => (document.hidden ? this.pause() : this.play());
      document.addEventListener('visibilitychange', this.visibilityHandler);

      this.play();
    }

    play() {
      if (!this.autoplayDelay || this.timer || document.hidden) return;
      this.timer = setInterval(() => {
        const next = this.activeIndex() + 1;
        this.scrollToCard(next >= this.cards.length ? 0 : next);
      }, this.autoplayDelay);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    buildDots() {
      this.dotsBox.replaceChildren();
      this.dots = this.cards.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `البطاقة ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToCard(i));
        this.dotsBox.appendChild(dot);
        return dot;
      });
    }

    scrollToCard(index) {
      const clamped = Math.max(0, Math.min(this.cards.length - 1, index));
      const card = this.cards[clamped];
      /* Scroll ONLY the track — scrollIntoView would also scroll the page vertically. */
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const delta = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
      this.track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    /* Nearest card to the track's leading edge — works in both RTL and LTR. */
    activeIndex() {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const edgeName = rtl ? 'right' : 'left';
      const edge = this.track.getBoundingClientRect()[edgeName];

      let best = 0;
      let min = Infinity;

      this.cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect()[edgeName] - edge);
        if (distance < min) {
          min = distance;
          best = i;
        }
      });

      return best;
    }

    onScroll() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.update);
    }

    update() {
      const index = this.activeIndex();
      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));

      /* scrollLeft is negative in RTL, so compare on absolute values. */
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = Math.abs(this.track.scrollLeft) < 4;
      const atEnd = Math.abs(Math.abs(this.track.scrollLeft) - maxScroll) < 4;

      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }
  }

  if (!customElements.get('trust-slider')) {
    customElements.define('trust-slider', TrustSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
